import { Link as RouterLink } from 'react-router-dom'
import { Banner, Button, Text } from '@cloudflare/kumo'
import { CameraIcon } from '@phosphor-icons/react'
import type { MyFaceStatus } from '@hub-wifi/shared'
import { useTranslation } from '../../i18n'

/** Self-service photo flow. `retake=1` asks it to open the photo step even
 * when a photo already exists. */
export const RETAKE_PHOTO_PATH = '/my/enroll?retake=1'

/** Coworker banner for the door reader's answer to their face photo.
 * Renders nothing unless the reader rejected the photo ('retake') or found
 * the face already enrolled ('duplicate'). */
export function FaceStatusBanner({ status }: { status: MyFaceStatus | null }) {
  const { t } = useTranslation()
  if (status !== 'retake' && status !== 'duplicate') return null

  const retake = status === 'retake'
  return (
    <div className="mb-3">
      <Banner variant="alert">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div>
            <Text as="p" DANGEROUS_className="font-medium">
              {t(retake ? 'faceStatus.retake.title' : 'faceStatus.duplicate.title')}
            </Text>
            <Text as="p" variant="secondary" size="sm">
              {t(retake ? 'faceStatus.retake.description' : 'faceStatus.duplicate.description')}
            </Text>
          </div>
          {retake && (
            <RouterLink to={RETAKE_PHOTO_PATH}>
              <Button variant="primary" size="sm" icon={<CameraIcon size={16} />}>
                {t('faceStatus.retake.button')}
              </Button>
            </RouterLink>
          )}
        </div>
      </Banner>
    </div>
  )
}
